import React from "react";

const DressIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20">
        <path
            d="m25.76 28-3-11 2-7a3.3 3.3 0 0 0-.35-2.67 4 4 0 0 0-.41-.47v-4h-2V5.4a5.36 5.36 0 0 0-2.69-.4A5.07 5.07 0 0 0 16 6.78 5.07 5.07 0 0 0 12.69 5a5.36 5.36 0 0 0-2.69.4V3a1 1 0 0 0-2 0v3.86a3.45 3.45 0 0 0-.39.53 3.3 3.3 0 0 0-.35 2.67l2 7L8 21.74a1 1 0 0 0 1.93.52L11.05 18h7a1 1 0 0 0 0-2H11L9.19 9.51a1.33 1.33 0 0 1 .11-1.06A3.36 3.36 0 0 1 12.45 7 3 3 0 0 1 15 9.21a1 1 0 0 0 2 0A3 3 0 0 1 19.55 7a3.37 3.37 0 0 1 3.15 1.45 1.33 1.33 0 0 1 .11 1.06l-2.06 7.22a1 1 0 0 0 0 .53L23.69 28H8.31l.75-2.74a1 1 0 0 0-1.93-.52L6.24 28a1.55 1.55 0 0 0 .26 1.38 1.6 1.6 0 0 0 1.26.62h16.48a1.6 1.6 0 0 0 1.26-.62 1.55 1.55 0 0 0 .26-1.38z"
          style={{fill:'#231f20'}}/>
    </svg>

);

export default DressIcon;
